import { configureStore } from '@reduxjs/toolkit'
import { getReduxDevToolsOptions } from 'common/helpers'
import type { TypedUseSelectorHook } from 'react-redux'
import { useDispatch, useSelector } from 'react-redux'

import rootReducer from './reducers'

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => {
      return getDefaultMiddleware({
        serializableCheck: {
          ignoredActionPaths: ['payload.notificationCloseCb'],
        },
      })
    },
    devTools: getReduxDevToolsOptions('Notification'),
  })
}

const store = setupStore()
export const getStore = () => store

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppDispatch = useDispatch<AppDispatch>
